import { FixedStepClock } from './core/loop';
import { applyFit, fitToBox } from './render/viewport';
import { RiverPlaceholder } from './scenes/riverPlaceholder';

declare const __BUILD_ID__: string;

declare global {
  interface Window {
    /** Debug/test hook. Read-only view of engine state for e2e tests. */
    __KAWAUS__?: { build: string; tick: () => number };
  }
}

function boot(): void {
  const canvas = document.querySelector<HTMLCanvasElement>('#game');
  if (!canvas) throw new Error('#game canvas missing');

  let ctx = resize(canvas);
  window.addEventListener('resize', () => {
    ctx = resize(canvas);
  });

  const clock = new FixedStepClock();
  const scene = new RiverPlaceholder(20260929);
  window.__KAWAUS__ = { build: __BUILD_ID__, tick: () => clock.tick };

  let last = performance.now();
  const frame = (now: number): void => {
    const steps = clock.advance(now - last);
    last = now;
    for (let i = 0; i < steps; i++) scene.step();
    scene.render(ctx);
    requestAnimationFrame(frame);
  };
  requestAnimationFrame(frame);
}

function resize(canvas: HTMLCanvasElement): CanvasRenderingContext2D {
  const fit = fitToBox(window.innerWidth, window.innerHeight);
  return applyFit(canvas, fit, Math.min(window.devicePixelRatio || 1, 3));
}

boot();
